'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.createSession = createSession;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
var _utilsJanus = require('../utils/janus');
var _utilsJanus2 = _interopRequireDefault(_utilsJanus);
var CREATE_SESSION = 'CREATE_SESSION';
exports.CREATE_SESSION = CREATE_SESSION;
var CREATE_SESSION_SUCCESS = 'CREATE_SESSION_SUCCESS';
exports.CREATE_SESSION_SUCCESS = CREATE_SESSION_SUCCESS;
var CREATE_SESSION_ERROR = 'CREATE_SESSION_ERROR';
exports.CREATE_SESSION_ERROR = CREATE_SESSION_ERROR;
function createSession(config) {
  console.log('MODULE -> reducer -> mcu ', config);
  return function (dispatch, getState) {
    _utilsJanus2['default'].init({
      debug: !!config.debug
    });
    var janus = new _utilsJanus2['default'](Object.assign({}, config.janus, {
      success: function success() {
        dispatch({
          type: CREATE_SESSION_SUCCESS,
          janus: janus
        });
      },
      error: function error(_error) {
        dispatch({
          type: CREATE_SESSION_ERROR,
          message: _error
        });
      }
    }));
    dispatch({
      type: CREATE_SESSION,
      config: config
    });
  };
}